import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { User } from '../interfaces/user.type';

@Injectable()
export class AuthenticationService {
    private USER_AUTH_API_URL: string;
    private currentUserSubject: BehaviorSubject<User>;
    public currentUser: Observable<User>;
    constructor(private http: HttpClient) {
        this.USER_AUTH_API_URL = environment.getBackendUrl('login/');
        this.currentUserSubject = new BehaviorSubject<User>(
            JSON.parse(localStorage.getItem('currentUser'))
        );
        this.currentUser = this.currentUserSubject.asObservable();
    }

    public get currentUserValue(): User {
        return this.currentUserSubject.value;
    }

    login(rut: string, password: string) {
        if (!environment.useBackend) {
            let user = {
                access: "",
                id: 1,
                username: rut,
                password: password
            };
            localStorage.setItem('currentUser', JSON.stringify(user));
            this.currentUserSubject.next(user);
            return of(user);
        }

        const body = {
            rut,
            password
        }

        return this.http.post<any>(this.USER_AUTH_API_URL, { rut, password }, {headers: {
            "Access-Control-Allow-Origin" : "*",
            "Access-Control-Allow-Methods" : "GET,POST,PUT,DELETE,OPTIONS",
            "Access-Control-Allow-Headers":
                "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With"
        }} )
        .pipe(map(user => {
            if (user && user.access) {
                console.log("USER ACCESS: ", user.access);
                localStorage.setItem('currentUser', JSON.stringify(user));
                this.currentUserSubject.next(user);
            }
            return user;
        }));
    }

    loginWithToken(token: string): Observable<any> {
        let user = {
            access: token,
            id: 1,
            username: "",
            password: ""
        };

        return this.http.post<any>(this.USER_AUTH_API_URL, { 'token':token }, {headers: {
            "Access-Control-Allow-Origin" : "*",
            "Access-Control-Allow-Methods" : "GET,POST,PUT,DELETE,OPTIONS",
            "Access-Control-Allow-Headers":
                "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With"
        }} )
            .pipe(map(user => {
                if (user && user.access) {
                    console.log("USER ACCESS: ", user.access);
                    localStorage.setItem('currentUser', JSON.stringify(user));
                    this.currentUserSubject.next(user);
                }
                return user;
            }));

      }


    logout() {
        localStorage.removeItem('currentUser');
        localStorage.removeItem('license');
        localStorage.removeItem('p');
        localStorage.removeItem('cc');
        this.currentUserSubject.next(null);
    }
}